import React from 'react';
import classes from './logo.scss';
class Logo extends React.Component {
  render() {
    const {
      styles,
      logoSrc,
      logoColors,
      getRef,
      onLogoLoad
    } = this.props;
    return /*#__PURE__*/React.createElement("img", {
      style: styles,
      "data-element": "logo",
      className: classes.logo,
      src: logoSrc,
      "data-colors": logoColors && logoColors.join(','),
      ref: getRef,
      onLoad: onLogoLoad,
      alt: "Logo"
    });
  }
}
export default Logo;